<template>
  <div class="jiaotong">
    <div class="titleList">
      <div class="inTitleList" v-for="(item, index) in contentList" :key="index" @click="change(index, item.type)"
        :class="{ active: current == index }">
        {{ item.type }}
      </div>
    </div>
    <div class="contentList">
      <div class="inContentList" v-for="item in inforList1" :key="item.id"
        @click="goContent(item.id, item.title, item.url)">
        <div class="biaoti">
          <div class="biaotiContent">
            <div class="biaotiWord" :class="{ hasImage: !item.image == '' }">
              <span class="zhidingIcon" v-show="item.istop == '是'">置顶</span>
              {{ item.title }}
              <span class="fire" v-show="item.ishotspot == '是'">
                <img src="../assets/images/fire.png" alt="" /></span>
            </div>
          </div>
          <div class="date">{{ item.pubtime }}</div>
        </div>

        <div class="rightPic" v-if="!item.image == ''">
          <img :src="item.image" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import qs from "qs";
import { Dialog } from "vant";
export default {
  mounted() {
    this.getContentList();
    this.getHeight();
  },
  data() {
    return {
      current: 1,
      contentList: [],
      inforObj: Object,
      inforList: [],
      inforList1: [],
      index: 1,
    };
  },
  methods: {
    hudong4Like(jiaotongName) {
      console.log(jiaotongName);
      this.inforList1 = [];
      let list = this.inforList.filter((v) => {
        if (v.title.includes(jiaotongName)) {
          return v;
        }
      });

      this.inforList1 = list;
    },
    getHeight() {
      let a = window.screen.availHeight;
      console.log(a);
      let c = document.querySelector(".head").clientHeight;
      console.log(c);
      document.querySelector(".jiaotong").style.height = a - 49 - 27 + "px";
    },
    change(index) {
      this.$emit("clearInput");
      this.current = index;
      this.index = index;
      this.inforList = [];
      this.inforObj = this.contentList[this.index];
      this.inforObj.informationList.forEach((item) => {
        item.pubtime = item.pubtime.substring(0, 10);
        this.inforList.push(item);
        this.inforList1 = JSON.parse(JSON.stringify(this.inforList));
      });
    },
    getContentList() {
      this.inforList = [];
      let params = qs.stringify({
        metacode: "TRANSPORTATION",
      });

      this.$axios
        .post("appapi/app/cmsInterface/getCmsInfo", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Dialog.alert({
              message: res.data.reason,
            }).then(() => { });
            return;
          }
          if (res.data.result === 1) {
            res.data.data.forEach((item) => {
              this.contentList.push(item);
              console.log(this.contentList);
            });
          }
          this.inforObj = this.contentList[this.index];

          this.inforObj.informationList.forEach((item) => {
            item.pubtime = item.pubtime.substring(0, 10);
            this.inforList.push(item);
            this.inforList1 = JSON.parse(JSON.stringify(this.inforList));
          });
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => { });
          return;
        });
    },
    goContent(id, title, url) {
      console.log(id);
      console.log(url);
      if (url) {
        this.$apis.CmsInterface.addIntegral(this.$axios, {
          type: 1,
          creditDesc: '阅读-交通出行'
        }).finally(() => {
          window.location.href = url;
        })
      } else {
        this.$router.push({
          name: "Injiaotong",
          query: {
            contentId: id,
            title,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.jiaotong {
  margin-bottom: 25rem;
  background-color: #fff;
  padding: 2.375rem 2rem 10rem 2rem;
  overflow-y: auto;
  overflow-x: hidden;
}

.titleList {
  display: flex;
  overflow-x: auto;

  .inTitleList {
    font-size: 1.75rem;
    color: #19212a;
    margin-right: 4.25rem;
    line-height: 2.625rem;
    white-space: nowrap;
  }

  .active {
    font-family: "ABeeZee";
    font-weight: bold;
    color: #19212a;
    font-size: 2rem;
    line-height: 2.375rem;
    white-space: nowrap;
  }
}

.contentList {
  margin-top: 1.25rem;

  .inContentList {
    display: flex;
    justify-content: space-between;
    padding: 2.125rem 0 2.875rem 0;
    border-bottom: 1px solid #e3e3e3;

    .biaotiWord {
      color: #3f3f3f;
      font-size: 2rem;
      line-height: 3rem;
      letter-spacing: 0.5px;

      .zhidingIcon {
        padding: 0.125rem 0.625rem;
        width: 4.625rem;

        color: #ffffff;
        background: #ff6433;
        border-radius: 0.5rem;
        font-size: 1.875rem;
        text-align: center;
      }
    }

    .hasImage {
      width: 27.875rem;
    }

    .date {
      color: #878787;
      font-size: 1.625rem;
      margin-top: 1rem;
    }

    .rightPic {
      width: 13.75rem;
      height: 9.75rem;

      img {
        width: 13.75rem;
      }
    }
  }
}
</style>